import fetch from 'isomorphic-fetch';
import { showFailure } from '../../common/toast';
import { browserHistory } from 'react-router';
// * snip
//* I have resolved token issue and also performing the testing all component
//* that's why i am not optimize this component but for now added in todo list
const apiPostCall = function sendRequest(url, data, done) {
  const  headers = { 'Content-Type': 'application/json' };
  const storageSession = JSON.parse(localStorage.getItem('localstorageval'));
  //find out who calls
  // console.trace("apiPostCall::trace ", url);
  let payload = {};
  if (storageSession) {
    const { idname = '', token = '' } = storageSession;
    payload = {
      token: token || '',
      idname: idname || '',
      id_name: idname || '',
    };
  }
  return fetch(url, {
    method: 'POST',
    //mode: 'CORS',
    body: JSON.stringify({ ...data, ...payload }),
    headers,
  })
    .then(async resp => {
      // Try to parse JSON regardless of HTTP status. The backend's global
      // errorHandler always returns JSON ({success:false, message:...}) for
      // structured errors (NotFoundError, BadRequestError, etc.), and we want
      // callers to receive that body so their existing `if (resp.success)` /
      // `else` branches can stop loaders and surface the error message —
      // throwing here leaves callers with unhandled rejections (infinite
      // spinners, no modal). Only throw when the body is genuinely non-JSON
      // (nodemon restart, proxy 502 HTML, etc.) so legacy logout-on-throw
      // behavior is preserved for that case.
      let data;
      try {
        data = await resp.json();
      } catch (parseErr) {
        const err = new Error(`HTTP ${resp.status}`);
        err.status = resp.status;
        throw err;
      }
      // For non-2xx responses with a JSON body, surface the message globally
      // (toast) AND return the body so per-page handlers can react. Skip
      // the toast for 401/403 because those typically trigger the token
      // expiry path below and would double up.
      if (!resp.ok) {
        if (resp.status !== 401 && resp.status !== 403 && data && data.message) {
          showFailure(data.message);
        }
        return { success: false, ...(data || {}), httpStatus: resp.status };
      }
      return data;
    })
    .then(data => {
      const msg = (data && data.message ? String(data.message) : '').toLowerCase();
      if (data && data.success === false && msg.includes('token') && msg.includes('invalid')) {
        localStorage.removeItem('localstorageval');
        showFailure('Token has been expired');
        browserHistory.push('/');
      }
      // Only force logout on getProfileInfo when the server explicitly tells us
      // the token is invalid. Generic success:false responses (or transient
      // errors) must not kick the user out.
      if (
        data &&
        data.success === false &&
        url.search('api/user/getProfileInfo') !== -1 &&
        msg.includes('token')
      ) {
        localStorage.removeItem('localstorageval');
        showFailure('Token has been expired');
        browserHistory.push('/');
      }
      return data;
    });
};

exports.callAPI = apiPostCall;



// WEBPACK FOOTER //
// ./src/views/RestAPI/fetchData.js